/* The roles of the team — the words, the colour and the sign. The owner wears the crown everywhere */
export const ROLES = {
    owner: { text: "Владелец", accent: "orange", icon: "crown" },
    admin: { text: "Администратор", accent: "violet", icon: "shield" },
    specialist: { text: "Специалист", accent: "blue", icon: "master" }
}

export const roleOf = key => {
    return ROLES[key] ? ROLES[key] : { text: key ? key : "—", accent: "grey", icon: "user" }
}

/* The roles a master holds in his living teams, the strongest first */
export const rolesOf = item => {
    return ["owner", "admin", "specialist"].filter(key => parseInt(item[key]) > 0)
}

/* A rating to one sign after the point */
export const ratingText = value => {

    if (value === null || value === undefined) {
        return "—"
    }

    return parseFloat(value).toFixed(1).replace(".", ",")
}
